<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <div class="text-right mb-3"></div>
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                            size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields"
                        :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light"
                        class="sa-b-table">
                        <template #cell(index)="row">
                            <span> {{ row.index + 1 }} </span>
                        </template>
                        <template #cell(descrizioneMetodoPagamento)="row">
                            <span style="font-weight: 600">{{ row.item.descrizioneMetodoPagamento }}</span>
                        </template>
                        <template #cell(fineMeseMetodoPagamento)="row">
                            <span style="font-weight: 600">{{ row.item.fineMeseMetodoPagamento ? "SI" : "NO" }}</span>
                        </template>
                        <template #cell(frazionamenti)="row">
                            <span style="font-weight: 600">{{ row.item.frazionamenti.length }}</span>
                        </template>
                        <template v-slot:cell(actions)="row">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Modifica" variant="outline-success"
                                    @click="onClickEditSoggetti(row.item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Cancella" variant="outline-danger"
                                    @click="onClickDeleteSoggetti(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                            size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/contabilitasoggettotipi",
            showModalLoading: false,
            listKey: 0,
            filtroMagazzinoArticoliCodici: {},
            items: [],
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 1rem",
                },
                {
                    label: "Matricola/Lotto Codice",
                    key: "lottoMatricola",
                    thStyle: "width: 5rem",
                },
                {
                    label: "Codice Articolo",
                    key: "codiceArticolo",
                    thStyle: "width: 5rem",
                },
                {
                    label: "Descrizione Articolo",
                    key: "descrizioneArticolo",
                    thStyle: "width: 5rem",
                },
                {
                    label: "Codice Azienda",
                    key: "codiceAzienda",
                    thStyle: "width: 1rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    mounted() { },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {


        loadData() {
            let me = this;
            me.openShowModalLoading();
            me.$emit("beforeLoadData");
            if (sessionStorage["filtroMagazzinoArticoliCodici"]) {
                me.filtroMagazzinoArticoliCodici = JSON.parse(sessionStorage["filtroMagazzinoArticoliCodici"]);
            }
            me.filtroMagazzinoArticoliCodici.page = me.currentPage;
            me.filtroMagazzinoArticoliCodici.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroMagazzinoArticoliCodici, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.closeShowModalLoading();
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.error("Errore durante il caricamento dei dati:", error);
            me.items = [];
            me.rows = 0;
            me.closeShowModalLoading();
            me.$emit("afterLoadData");
        }
    },
};
</script>

<style scoped></style>
